import { v1ApiClient } from '@/services';
import type { Operation } from '@/shared/api/generated';

type DeleteAggregatedReportFolderOperation =
  Operation<'DeleteAggregatedReportFolder'>;

export type DeleteAggregatedReportFolderParams =
  DeleteAggregatedReportFolderOperation['parameters']['path'];

export const deleteAggregatedReportFolder = ({
  workspace_id,
  folder_id,
}: DeleteAggregatedReportFolderParams) =>
  v1ApiClient
    .delete(
      `/workspaces/${workspace_id}/aggregated-report-folders/${folder_id}`,
    )
    .then((res) => res.data);
